import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';

const cellEditProp = {
  mode: 'dbclick',
  blurToSave: true,
};

function userDataFormat(cell) {
  return (
    <Link to={`/users/${cell}`}>
      <div>
        {cell}
      </div>
    </Link>
  );
}

export default class UserListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      query: {},
      username: '',
    };
    this.onCellEdit = this.onCellEdit.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    const { query } = this.state;
    this.getData(query);
  }

  onCellEdit(row, fieldName, value) {
    const { data } = this.state;
    let rowIndex;
    const targetRow = data.find(
      (currentRow, index) => {
        if (currentRow.id === row.id) {
          rowIndex = index;
          return true;
        }
        return false;
      },
    );

    if (targetRow && targetRow[fieldName] !== value) {
      targetRow[fieldName] = value;
      data[rowIndex] = targetRow;
      const userParams = {};
      userParams[fieldName] = value;
      BlitzAPI.patchAnyUser(row.id, { user: userParams }).then(
        response => console.log(response),
      );
      this.setState({ data });
    }
  }

  onUsernameChange(e) {
    this.setState({ username: e.target.value });
    let { query } = this.state;
    if (!e.target.value) {
      delete query.username;
    } else {
      query = Object.assign({}, query, { username: e.target.value });
    }
    this.setState({ query }, this.getData);
  }

  getData() {
    const { query } = this.state;
    BlitzAPI.getUsers(query).then(
      (resp) => {
        return this.setState({ data: resp.data.data });
      },
    );
  }

  render() {
    const { data, username } = this.state;

    return (
      data ?
        <div>
          <div>
            <label htmlFor="userSearch">Search</label>
            <input value={username} onChange={this.onUsernameChange} />
          </div>
          <BootstrapTable
            data={this.state.data}
            remote striped hover
            cellEdit={cellEditProp}
            options={{ onCellEdit: this.onCellEdit }}
          >
            <TableHeaderColumn
              isKey dataField="id"
              dataFormat={userDataFormat}
            >User ID</TableHeaderColumn>
            <TableHeaderColumn dataField="username">Username</TableHeaderColumn>
            <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
            <TableHeaderColumn dataField="email">Email</TableHeaderColumn>
            <TableHeaderColumn dataField="banned" editable={{ type: 'checkbox' }}>Banned</TableHeaderColumn>
            <TableHeaderColumn dataField="image_url" editable>Image URL</TableHeaderColumn>
            <TableHeaderColumn dataField="bio" editable>Biography</TableHeaderColumn>
          </BootstrapTable>
        </div> : <div><h1>Loading</h1></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/user/UserListTable.js